<div class="alert alert-error has-icon alert-large" role="alert">
  <span><i class="fal fa-times-circle me-3 mt-1"></i></span>
  <div class="alert-content">
    <p class="mb-0">{{message}}</p>
  </div>
</div>
